/**
 * 記事編集画面のMT標準のフィールドと同じ形式のHTMLを作成します。
 *
 * Updated: 2023/09/29
 *
 * 使用例:
 * ```
 * const html = mtapp.makeField({
 *     basename: 'exampleId',
 *     label: 'ラベルテキスト',
 *     content: '<input type="text" class="form-control">',
 *     hint: 'このフィールドは入力必須です。',
 *     required: true,
 *     type: 'entry' // 'entry' or 'cd'
 * });
 * document.querySelector('#title-field').insertAdjacentHTML('afterend', html);
 * document.querySelector('#contentField1').insertAdjacentHTML('afterend', html);
 * ```
 *
 * @param {Object} options
 * @param {String} options.basename フィールドのID。自動で -field が付与されます。
 * @param {String} options.label ラベル部分のテキスト、HTML
 * @param {String} options.content コンテンツ部分のテキスト、HTML
 * @param {String} options.hint コンテンツのヒント部分のテキスト、HTML
 * @param {Boolean} [options.required=false] 必須フィールドであるかどうか
 * @param {String} options.type フィールドのタイプ（'entry' or 'cd'）
 * @returns {string}
 */
import { temporaryId } from './temporaryId.js';

export function makeField(options) {
    const defaultOptions = {
        basename: '',
        label: '',
        content: '',
        hint: '',
        required: false,
        type: 'entry' // デフォルトは 'entry'
    };

    const op = { ...defaultOptions, ...options };

    const basename = op.basename || temporaryId();
    const hint = op.hint ? `<small class="form-text text-muted">${op.hint}</small>` : '';
    const requiredBadge = op.required ? '<span class="badge badge-danger">必須</span>' : '';

    if (op.type === 'entry') {
        return `
            <div id="${basename}-field" class="mt-3 field">
                <div class="mt-draggable--entryField">
                    <div class="col p-0 ml-4">
                        <label class="form-control-label form-label">${op.label} ${requiredBadge}</label>
                    </div>
                    <div class="mt-draggable__content">${op.content}${hint}</div>
                </div>
            </div>
        `;
    } else if (op.type === 'cd') {
        return `
            <div class="mb-3">
                <label class="form-label">${op.label} ${requiredBadge}</label>
                ${op.content}
                ${hint}
            </div>
        `;
    }
}
